/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { createSlice } from '@reduxjs/toolkit'
import { RootState } from './store';

// Define a type for the slice state
interface ReRenderState {
  reRender: number
}

// Define the initial state using that type
const initialState: ReRenderState = {
  reRender: 0,
}

export const reRenderSlice = createSlice({
  name: 'reRender',
  initialState,
  reducers: {
    callRender: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.reRender =state.reRender+1;
    },
  },
})

// Action creators are generated for each case reducer function
export const { callRender} = reRenderSlice.actions;
export const reRenderSelector = (state: RootState) => state.reRender;

export default reRenderSlice.reducer;